import { RegisterFormPerson } from "models/register";
import React from "react";
import { Form } from "react-bootstrap";

interface RegisterPersonFormProps {
    name?: string;
    personalIdentificationCode: string;
    form: RegisterFormPerson;
    error?: string;
    setForm: (form: RegisterFormPerson) => void;
}

export default function RegisterPersonForm(
    { name, personalIdentificationCode, form, setForm, error } : RegisterPersonFormProps) {

    return (
        <div className="container w-100 h-100 bg-white p-3 p-lg-5">
            <h1 className="text-dark u-fs-40 mb-3">Erakliendi konto loomine</h1>
            <p className="u-fs-14 text-gray-700">Registreeri oma ID-kaart kliendikaardiks täiesti Tasuta!<br/>Kohustuslikud väljad on tähistatud TÄRNIGA <sup>*</sup></p>
            { !!error && <div className="alert alert-danger mt-2">
                <i className='alert-icon icon__info--masked bg-danger mr-2'></i> Ettevõtte registreerimine ebaõnnestus: { error }
            </div>}
            <div className="u-hr mt-4"></div>
            <div className="row">
                <div className="col-12 col-lg-6">
                    <Form.Label>
                        Nimi
                    </Form.Label>
                    <Form.Control className={''}
                        value={name}
                        disabled={true}
                        type="text" />
                </div>
                <div className="col-12 col-lg-6 mt-3 mt-lg-0">
                    <Form.Label>
                        Isikukood
                    </Form.Label>
                    <Form.Control className={''}
                        value={personalIdentificationCode}
                        disabled={true}
                        type="text" />
                </div>                
            </div>
            <div className="row mt-3">
                <div className="col-12 col-lg-6">
                    <Form.Label>
                        Kontakti tel. number <sup>*</sup>
                    </Form.Label>
                    <Form.Control className={''}
                        required
                        value={form.contactPhone}
                        onChange={(e) => setForm({ ...form, contactPhone: e.target.value })}
                        type="text" />
                </div>     
                <div className="col-12 col-lg-6  mt-3 mt-lg-0">
                    <Form.Label>
                        Kontakti e-post <sup>*</sup>
                    </Form.Label>
                    <Form.Control className={''}
                        required
                        value={form.contactEmail}
                        onChange={(e) => setForm({ ...form, contactEmail: e.target.value })}
                        type="text" />
                </div>           
            </div>
            <div className="u-hr mt-5"></div>
            <Form.Check
                id='check-newsletter'
                custom
                type="checkbox"
                label="Soovin uudiskirjana teavet kliendipakkumiste ja soodustuste kohta."
                className='checkbox-large mt-4'
                onChange={() => setForm({ ...form, wantsNewsLetter: !form.wantsNewsLetter })}
                checked={form.wantsNewsLetter}
            />
            <Form.Check
                id='check-terms-person'
                custom
                type="checkbox"
                label={<>Kinnitan esitatud andmete õigsust ja olen tutvunud Terminal Oili <a href="https://terminalenergia.ee/andmekaitsetingimused/" target="_blank" rel="noopener noreferrer">andmekaitsetingimustega</a></>}
                className='checkbox-large mt-4'
                onChange={() => setForm({ ...form, termsAndConditions: !form.termsAndConditions })}
                checked={form.termsAndConditions}
            />
            <p className="u-fs-14 text-gray-700 mt-4">Terminal AS töötleb Teie andmeid kooskõlas isikuandmete kaitse seadustega ning võite olla kindel, et need on kolmandate osapoolte eest kaitstud. Lisainfo: <a href="https://terminalenergia.ee/andmekaitsetingimused/" target="_blank" rel="noopener noreferrer">Privaatsuspoliitika</a></p>
        </div>
    );
}
